import Vue from "vue";
import App from "./App.vue";
import VModal from "vue-js-modal";
require("dotenv").config();
import "normalize.css/normalize.css"; // a modern alternative to CSS resets
import Element from "element-ui";
import "./styles/element-variables.scss";

import "@/styles/index.scss"; // global css
import store from "./store";
import router from "./router";
import locale from "element-ui/lib/locale/lang/en";
import VueOtp2 from 'vue-otp-2';
import VueClipboard from 'vue-clipboard2'
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import SocketUtils from "./utils/SocketUtils";

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
Vue.use(VModal);
Vue.use(VueTelInput, {})
Vue.use(Element, { locale });
SocketUtils.init();
Vue.use(VueOtp2)

Vue.config.productionTip = false;
Vue.config.silent = true;

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
